import React from 'react';
import ClassroomModal from './ClassroomModal';
import type { ResolvedStageMission } from '../../classroom/missionLayers';

interface MissionNotesModalProps {
  mission: ResolvedStageMission | null;
  onClose: () => void;
  onTakeReflectionPhotos?: () => void;
  squadAvatarUrl?: string;
  teamAvatars?: Array<{name:string;url?:string}>;
}

const REFLECTION_QUESTIONS = [
  'What did you make or work on today?',
  'What is one choice your team made—and why?',
  'What was surprising, tricky, or different from what you expected?',
  'What did you learn today?',
  'What would you change or try next time?',
];

const MissionNotesModal: React.FC<MissionNotesModalProps> = ({ mission, onClose, onTakeReflectionPhotos, squadAvatarUrl, teamAvatars=[] }) => {
  if (!mission) return null;
  return (
    <ClassroomModal isOpen title={mission.title} onClose={onClose} width={560}>
      <div className="cd-mission-notes">
        {mission.missionType === 'reflect' && <section className="cd-reflection-guide">
          {(squadAvatarUrl || teamAvatars.some(t=>t.url)) && <div className="cd-reflection-avatars">{squadAvatarUrl&&<img className="is-squad" src={squadAvatarUrl} alt="Squad avatar"/>}{teamAvatars.filter(t=>t.url).map(t=><span key={t.name}><img src={t.url} alt=""/><small>{t.name}</small></span>)}</div>}
          <div className="cd-reflection-photo-prompt">
            <span className="cd-reflection-photo-icon" aria-hidden="true">📷</span>
            <div>
              <h3>Capture what students made today</h3>
              <p>Photograph each team’s paper work before cleanup. Choose the team and today’s class in the uploader so it lands in the right portfolio.</p>
            </div>
            <button type="button" className="cd-btn cd-btn-primary" onClick={onTakeReflectionPhotos}>
              Take photos of student work
            </button>
          </div>
          <div className="cd-reflection-questions">
            <div className="cd-briefing-slot-label">Ask the group</div>
            <p className="cd-reflection-intro">Pick two or three—students can answer aloud, point to their work, or share with a partner.</p>
            <ol>{REFLECTION_QUESTIONS.map((question) => <li key={question}>{question}</li>)}</ol>
          </div>
        </section>}
        <div className="cd-briefing-slot-label">Teaching notes</div>
        {mission.script.length ? <ol>{mission.script.map((step, index) => <li key={index}><b>{step.kind === 'say' ? 'Say:' : 'Do:'}</b> {step.text}</li>)}</ol> : mission.notesBlob ? (
          /<\/?[a-z][\s\S]*>/i.test(mission.notesBlob)
            ? <div className="cd-rich-notes" dangerouslySetInnerHTML={{ __html: mission.notesBlob }} />
            : <p>{mission.notesBlob}</p>
        ) : <p>Teaching notes will be added when this lesson is developed.</p>}
        {mission.attachments.length > 0 && <div className="cd-mission-attachments">
          <div className="cd-briefing-slot-label">Activity files</div>
          {mission.attachments.map((attachment) => attachment.kind === 'video' ? (
            <div className="cd-mission-attachment-video" key={attachment.id || attachment.url}>
              <strong>{attachment.title}</strong>
              <video src={attachment.url} controls playsInline />
            </div>
          ) : (
            <a className="cd-resource-link" key={attachment.id || attachment.url} href={attachment.url} target="_blank" rel="noreferrer">
              <span className="cd-resource-kind">DOCUMENT</span><span><strong>{attachment.title}</strong></span><b>Open ↗</b>
            </a>
          ))}
        </div>}
        {mission.missionType === 'reveal' && <div className="cd-coming-soon">Use the Reveal &amp; Review mission row to launch the projector flow.</div>}
      </div>
    </ClassroomModal>
  );
};
export default MissionNotesModal;
